import { Breadcrumbs } from "components/breadcrumbs";
import { useCreate } from "@refinedev/core";
import { FullScreenLoading } from "components/fullScreenLoading";
import toast from "react-hot-toast";
import { IAttractionQRCodeForm } from "interfaces";
import { useNavigate } from "react-router-dom";
import { AttractionQRCodeForm } from "./components";

export const CreateAttractionQRCode: React.FC = () => {

  const { mutate, isLoading: isSubmitingSubCategoryForm } = useCreate();
  const navigate = useNavigate();

  const onSubmit = (values: IAttractionQRCodeForm) => {
    const submitValues = { ...values };
    mutate(
      {
        resource: "participant/ecodes/bulk-create",
        meta: {
          ignoreResourceWrapper: true,
        },
        values: {
          ...submitValues,
        },
      },
      {
        onSuccess: () => {
          toast.success("Create successfully");
          navigate(`/events/attraction-qr-code`);
        },
      }
    );
  };

  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Create new QR Code" />
      <AttractionQRCodeForm onSubmit={onSubmit} />
      {isSubmitingSubCategoryForm ? <FullScreenLoading /> : <></>}
    </div>
  );
};
